import React, { useEffect } from "react";
import { Backdrop, Portal } from "@mui/material";
import { useIsDraggingFile } from "../../hooks/use-is-dragging-file";

export const FileDragUploadBackdrop = (
    { onFileDragging }: { onFileDragging: (isDragging: boolean) => void },
) => {
    const isDraggingFile = useIsDraggingFile();

    useEffect(() => {
        onFileDragging(isDraggingFile);
    }, [isDraggingFile]);

    return <Portal>
        <Backdrop open={isDraggingFile} sx={{ zIndex: 256 }}  />
    </Portal>;
};
